/**
 * The short kind-of-file label on an attachment chip: "PNG", "PDF".
 *
 * Read off the filename rather than the mime type, because that is the word the person who
 * attached the file would use for it, and because office formats carry mime subtypes
 * (`vnd.openxmlformats-officedocument.wordprocessingml.document`) that no chip can show. The
 * mime subtype is the fallback for a file that arrived without an extension.
 *
 * Returns null when neither source gives anything short enough to read as a type, so the chip
 * omits the segment instead of printing a shrug.
 */
const MAX_LABEL_LENGTH = 5;

export function attachmentTypeLabel(name: string, mimeType: string): string | null {
  const extension = name.slice(name.lastIndexOf('.') + 1);
  if (name.includes('.') && extension.length > 0 && extension.length <= MAX_LABEL_LENGTH) {
    return extension.toUpperCase();
  }

  const subtype = mimeType.slice(mimeType.indexOf('/') + 1);
  if (subtype.length > 0 && subtype.length <= MAX_LABEL_LENGTH) {
    return subtype.toUpperCase();
  }

  return null;
}
